import React from 'react';

import BeerSubscription from 'AppRoutes/BeerSubscription';
import type { SubscriptionCampaignConfig } from 'utils/types/SubscriptionCampaignConfig';

const BEERTRIP_CAMPAIGN: SubscriptionCampaignConfig = {
  bannerImage: '/images/beertrip_clube42.jpg',
  bannerStorageKey: 'banner_closed_beertrip10anos',
  defaultPackQuantity: 4,
};

const BeerTripSubscription = () => (
  <BeerSubscription campaign={BEERTRIP_CAMPAIGN} />
);

export default BeerTripSubscription;
